import { Component, OnDestroy, OnInit } from '@angular/core';
import { BroadcastEventModel, BroadcastService, ToasterType } from '@cv-invision/core';
import { Store } from '@ngxs/store';
import { ProductsService } from '../service/products.service';
import { GlobalConfigurationState } from '../../state/global-configuration.state';
import {
	ProductsModel,
	SubProduct,
	SubProductInfo,
	TrackingSystemConfigurationInfo,
	TrakingListModel,
	LicensingServiceSetting,
	ProductsData,
	AutoCompleteScopeOrder,
	AppScopeTrakingConfigurationInfo,
	LineOfBussiness, ListOptions, InspectionConfiguration
} from '../model/product.model';
import {
	MSG_FIELDS_OPTIONS,
	MSG_FIELDS_VALUE,
	GSE_PREFERENCE,
	ORIGIN_LIST,
	ClassValuationIntegration,
	CREATION_TRIGGER,
	SCOPE_ORDER_UPDATE_DOCUMENTS,
	LINE_BUSINESS_LIST, ACUITY_TYPES_ORIGIN_LIST
} from '../model/product-constant';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { lastValueFrom, Subject } from 'rxjs';
import { GenericIntegrationService } from '../../service/generic-integration.service';
const NEW_MODE = 'NEW';
const INTEGRATIONS = ['nexsys', 'xpanse', 'fnc', 'valutrust', 'integration'];

@Component({
	selector: 'cv-invision-create-update-products',
	templateUrl: './create-update-products.component.html',
	styleUrls: ['./create-update-products.component.scss'],
})
export class CreateUpdateProductsComponent implements OnInit, OnDestroy {
    viewMode: boolean = false;
    private atComponentDestroy = new Subject();
    productData: ProductsModel = new ProductsModel();
    originalProductData: ProductsModel = new ProductsModel();
    saving: boolean = false;
    appScopeProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getAppScopeProducts);
    acuityProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getAcuityProducts);
	milestoneAcuityList: Array<any> = [];
    nexsysProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getNexsysProducts);
    valutrustProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getValuTrustProducts);
    xpanseProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getXpanseProducts);
    fncProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getFNCProducts);
    genericIntegrationList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getGenericIntegrationsIdNameObjectType);

    genericIntegrationSelected: any = {};
    insideMapsProductList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getInsideMapsProducts);
    nexsysAttributesList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getNexsysAttributeList);
    assetsOnCompletionAppscope: Array<any>;
    assetsOnCompletionAcuity: Array<any>;
    schemasList: Array<any>;
    licensingSubProductCreationTriggerList: Array<any> = [
        {
            id: 'Manage3DScan',
            name: 'Incoming Managed 3D Scan'
        },
        {
            id: 'VirtualInspection',
            name: 'Incoming Virtual Inspection'
        },
    ];
    canSetNexsys: boolean = true;
    canSetAcuity: boolean = true;
    canSetAppScope: boolean = true;
    canSetSideCar: boolean = false;
    errorMessages: Array<any> = [];
    enableAcuityMsg: string;
    enableAppScopeMsg: string;
    productId: string = this.activateRoute.snapshot.paramMap.get('prodId');
    isEdit: boolean = false;
    hasOrigin: boolean;
    clearProductIntegration: boolean;
    subProductList: Array<any>;
    gsePreference = GSE_PREFERENCE;
    originList = ORIGIN_LIST;
    softwareCollector = [];
    classValuationIntegration: ClassValuationIntegration = new ClassValuationIntegration();
    creationTriggerList = CREATION_TRIGGER;
    creationTriggerSelected: TrakingListModel = new TrakingListModel();
    creationTriggerSubProductSelected: TrakingListModel = new TrakingListModel();
    assetsAppscopeSelected: any = {
        id: '',
        description: '',
    };
    assetsAcuitySelected: any = {
        id: '',
        description: '',
    };
    sideCar1: SubProductInfo = new SubProductInfo();
    sideCar2: SubProductInfo = new SubProductInfo();
    acuityLicensingSubProduct1: ProductsData = new ProductsData();
    acuityLicensingSubProductCreationTrigger1: any = [];
    acuityLicensingSubProduct2: ProductsData = new ProductsData();
    acuityLicensingSubProductCreationTrigger2: any = [];
    gsePreferenceSelected: SubProductInfo = new SubProductInfo();
    originSelected: SubProductInfo = new SubProductInfo();
    insideMapsSelected: TrakingListModel = new TrakingListModel();
    associatedProductSelected: TrakingListModel = new TrakingListModel();
    acuitySelected: Array<TrakingListModel> = [];
    acuityLicensingServiceSelected: Array<TrakingListModel> = [];
    appScopeSelected: Array<TrakingListModel> = [];
    milestoneSelected?: TrakingListModel;
    milestoneSubProductSelected?: TrakingListModel;
    dmLinkSelected?: TrakingListModel;
    nexsysAttributeSelected: Array<TrakingListModel> = [];
    schemaSelected: SubProductInfo = new SubProductInfo();
    showLicensingButton: boolean = false;
    enableLicensingService: boolean = false;
    autoCompleteMilestoneSelected?: Array<TrakingListModel> = [];
    uploadDocumentsMilestoneSelected?: Array<TrakingListModel> = [];
    lineSelected: LineOfBussiness = new LineOfBussiness();
    lineBusinessList = LINE_BUSINESS_LIST;
	acuityTypesOrigin: Array<ListOptions> = ACUITY_TYPES_ORIGIN_LIST;
	acuityOriginSelected = null;
    public title: string;

    constructor(
        private store: Store,
        private productService: ProductsService,
        private genericIntegrationService: GenericIntegrationService,
        private broadcastService: BroadcastService,
        private activateRoute: ActivatedRoute,
        private router: Router
    ) {
        this.appScopeProductList = this.appScopeProductList.map(
            (appScopeProduct) => {
                return {
                    id: appScopeProduct.id,
                    title: '(' + appScopeProduct.id + ') ' + appScopeProduct.title,
                };
            }
        );
    }

    async ngOnInit(): Promise<void> {
        if (this.productId) {
            this.isEdit = true;
            this.title = 'Edit Product Configuration';
        } else {
            this.title = 'Create Product Configuration';
        }

		this.schemasList = await lastValueFrom(this.productService.getSchemas()).catch(e => console.error(e));

        this.creationTriggerSelected = this.creationTriggerList[0];
        this.productService.getAssetsOnCompletion('Acuity')
            .pipe(takeUntil(this.atComponentDestroy))
            .subscribe((result) => {
				if (result) {
					this.assetsOnCompletionAcuity = result;
				}
			});
        this.productService
            .getAssetsOnCompletion('AppScope')
            .pipe(takeUntil(this.atComponentDestroy))
            .subscribe((result) => {
                if (result) {
                    this.assetsOnCompletionAppscope = result;
                }
            });

        this.productService.getOptionsSoftwareColector()
            .pipe(takeUntil(this.atComponentDestroy))
            .subscribe((result) => {
				this.softwareCollector = result.data;
			});

        if (this.productId) {
            this.lineBusinessList = LINE_BUSINESS_LIST;
            this.productService
                .getProdcutListById(this.productId)
                .pipe(takeUntil(this.atComponentDestroy))
                .subscribe((response) => {
                    this.productData = response;

                    if (!this.productData.acuity.autoCompleteScopeOrderOption) {
                        this.productData.acuity.autoCompleteScopeOrderOption = new AutoCompleteScopeOrder();
                    }

                    this.originalProductData = {...this.productData};
                    this.enableLicensingService = this.productData.licensingServiceSetting.enabled;

                    if (this.enableLicensingService) {
                        this.acuityLicensingServiceSelected = [
                            {
                                id: this.productData.licensingServiceSetting.acuityCreationSetting.acuityProductId,
                                title: this.productData.licensingServiceSetting.acuityCreationSetting.acuityProductName
                            }
                        ]

                        this.acuityLicensingSubProduct1 = this.productData.licensingServiceSetting.subProductConfiguration.products[0];
                        this.acuityLicensingSubProduct2 = this.productData.licensingServiceSetting.subProductConfiguration.products[1];

                        this.acuityLicensingSubProductCreationTrigger1 = this.licensingSubProductCreationTriggerList.find(SubProductCreationTrigger => SubProductCreationTrigger.id === this.acuityLicensingSubProduct1.creationTrigger);
                        this.acuityLicensingSubProductCreationTrigger2 = this.licensingSubProductCreationTriggerList.find(SubProductCreationTrigger => SubProductCreationTrigger.id === this.acuityLicensingSubProduct2.creationTrigger);
                    }

                    // GSE reference
                    const gse = this.gsePreference.filter(
                        (g) => g.id === this.productData.inspection.gsePreference
                    );
                    if (gse.length) {
                        this.gsePreferenceSelected = gse[0];
                    }
                    // origin reference
                    const orig = this.originList.filter(
                        (g) => g.id === this.productData.origin
                    );
                    if (orig.length) {
                        this.originSelected = orig[0];
                        this.onOriginSelected(this.originSelected, 'EDIT');

						if(this.canSetAcuity) {
							const acuityOrigin = this.acuityTypesOrigin.filter(
								(g) => g.id === this.productData.acuity.instance?.toLowerCase()
							);
							this.acuityOriginSelected = acuityOrigin[0];
							this.setAcuityOptionsList(this.acuityOriginSelected.id);
						}
                    }

					const autoCompleteMilestoneSelected = this.milestoneAcuityList.filter(
						(milestone) => milestone.id === this.productData.acuity.autoCompleteScopeOrderOption.autoCompleteMilestoneTrigger
					)

					if (autoCompleteMilestoneSelected.length) {
						this.autoCompleteMilestoneSelected = autoCompleteMilestoneSelected;
					}

					const uploadDocumentsMilestoneSelected = this.milestoneAcuityList.filter(
						(milestone) => milestone.id === this.productData.acuity.autoCompleteScopeOrderOption.uploadDocumentsMilestone
					)

					if (uploadDocumentsMilestoneSelected.length) {
						this.uploadDocumentsMilestoneSelected = uploadDocumentsMilestoneSelected;
					}

                    // line businees reference
                    const lineBussines= this.lineBusinessList.filter(
                        (g) => g.id === this.productData.channel
                    )
                    if (lineBussines.length) {
                        this.lineSelected = lineBussines[0];
                    }

                    // inside maps reference
                    const insM = this.insideMapsProductList.filter(
                        (g) => g.id === this.productData.insideMaps.insideMapsId
                    );
                    if (insM.length) {
                        this.insideMapsSelected = insM[0];
                    }

                    INTEGRATIONS.forEach(index => {
                        if (this.productData[index].enabled) {

                            this.activateSection(index, this.productData[index].enabled);

                            if (index === 'integration') {
                                this.onGenericIntegrationSelected({
                                    id: this.productData.integration.integrationId,
                                    name: this.productData.integration.name
                                });

                                this.classValuationIntegration.optionSelected = [{
                                    id: this.productData.integration.productId,
                                    title: this.productData.integration.productName
                                }];

                            } else {
                                const value = this[`${index}ProductList`].filter(
                                    (g) => g.id === this.productData[index].productId
                                );
                                if (value.length) {
                                    this.classValuationIntegration.optionSelected = value;
                                }
                            }

                            this.classValuationIntegration = {
                                ...this.classValuationIntegration,
                                ...this.productData[index]
                            };

                            if (index === 'nexsys') {
                                if (this.productData.nexsys.orderAttribute) {
                                    const nxysAttr = this.nexsysAttributesList.filter((nt) =>
                                        this.productData.nexsys.orderAttribute.includes(nt.title)
                                    );
                                    if (nxysAttr.length) {
                                        this.nexsysAttributeSelected = nxysAttr;
                                    }
                                }
                            }
                        }
                    });

                    // acuity porduct  reference
                    const acut = this.acuityProductList.filter(
                        (g) => g.id === this.productData.acuity.productId
                    );
                    if (acut.length) {
                        this.acuitySelected = acut;
                    }

                    // appscope porduct  reference
                    const appS = this.appScopeProductList.filter(
                        (g) => g.id === this.productData.appScope.jobId
                    );
                    if (appS.length) {
                        this.appScopeSelected = appS;
                    }

                    // let the endpoint from assets has time to respone
                    setTimeout(() => {
                        const statusChanged = 'StatusChanged';

                        // acuity schema reference
                        const insschema = this.schemasList.filter(
                            (g) => g.name === this.productData.inspection.schema
                        );
                        if (insschema.length) {
                            this.schemaSelected = insschema[0];
                        }
                        // milestone assets
                        this.creationTriggerSelected = this.creationTriggerList.filter(
                            (c) => c.id === this.productData.appScope.creationTrigger
                        )[0];
                        if (this.creationTriggerSelected.id === statusChanged) {
                            this.milestoneSelected = this.milestoneAcuityList.filter(
                                (m) => m.id === this.productData.appScope.creationStatusTrigger
                            )[0];
                        }

                        if (this.productData.appScope.enqueueCommunications) {
                            const aProduct =
                                this.classValuationIntegration.productList.filter(
                                    (cp) =>
                                        cp.id ===
                                        this.productData.appScope.associatedOrderProductType
                                );
                            if (aProduct.length) {
                                this.associatedProductSelected = aProduct[0];
                            }
                        }

                        if (this.productData.acuity.bpoProduct) {
                            this.dmLinkSelected = this.milestoneAcuityList.filter(
                                (m) => m.id === this.productData.acuity.bpoLinkTrigger
                            )[0];
                        }

                        // acuity assets  reference
                        const assestAcuity = this.assetsOnCompletionAcuity?.filter(
                            (a) => a.id === this.productData.acuity.productAssetsId
                        );
                        if (assestAcuity.length) {
                            this.assetsAcuitySelected = assestAcuity[0];
                        }
                        // acuity assets  reference
                        const assestAppscope = this.assetsOnCompletionAppscope?.filter(
                            (a) => a.id === this.productData.appScope.productAssetsId
                        );
                        if (assestAppscope.length) {
                            this.assetsAppscopeSelected = assestAppscope[0];
                        }
                        // side cards  reference
                        const { products } = this.productData.subProductConfiguration;
                        if (products.length) {
                            this.sideCar1 = products[0];
                            this.creationTriggerSubProductSelected =
                                this.creationTriggerList.filter(
                                    (c) => c.id === this.sideCar1.creationTrigger
                                )[0];
                            if (
                                this.creationTriggerSubProductSelected.id === statusChanged
                            ) {
                                this.milestoneSubProductSelected =
                                    this.milestoneAcuityList.filter(
                                        (m) => m.id === this.sideCar1.creationStatusTrigger
                                    )[0];
                            }
                            if (products.length > 1) {
                                this.sideCar2 = products[1];
                            }
                        }
                    }, 200);
                });
        } else {
            this.handleFieldMsg('', NEW_MODE);
        }

        this.productService
            .getSavingProductListener()
            .pipe(takeUntil(this.atComponentDestroy))
            .subscribe((result) => {
                if (result && result.saving) {
                    this.onSave();
                }
            });

        this.registerUpdateDocumentsListener();
    }

    /**
     * On Save button.
     */
    onSave(): void {
        this.saving = true;
        this.errorMessages = [];
        const { integrationName } = this.classValuationIntegration;
        this.productData.subProductConfiguration = new SubProduct();
        this.productData.subProductConfiguration.products = [];
        this.productData.channel = this.lineSelected?.name;

        if (this.sideCar1 && this.sideCar1.id) {
            this.productData.subProductConfiguration.products.push(this.sideCar1);
        }
        if (this.sideCar2 && this.sideCar2.id) {
            this.productData.subProductConfiguration.products.push(this.sideCar2);
        }

        INTEGRATIONS.forEach(index => {
            if (integrationName === index) {
                this.productData[index] = {
                    ...this.productData[index],
                    ...this.classValuationIntegration,
                };
            } else {
                this.productData[index] = null;
                this.productData[index] = new TrackingSystemConfigurationInfo();
            }
        });

        if (this.productId) {
            this.productService
                .updateProduct(this.productId, this.productData)
                .pipe(takeUntil(this.atComponentDestroy))
                .subscribe(
                    (response) => {
                        if (response.succeeded) {
                            this.successHandleFunction();
                        }
                    },
                    (error) => {
                        this.errorMessages = error.error.error.split(',');
                        this.saving = false;
                    }
                );
        } else {
            this.productService.setNewProduct(this.productData)
                .pipe(takeUntil(this.atComponentDestroy))
                .subscribe(
                (response) => {
                    if (response.succeeded) {
                        this.successHandleFunction();
                    }
                },
                (error) => {
                    this.errorMessages = error.error.error.split(',');
                    this.saving = false;
                }
            );
        }
    }

    /**
     * on save product
     */
    onCancel(): void {
        this.router.navigate([`/global-configuration/product/product-list`]);
    }

	/**
	 * Is form valid?
	 */
	isFormValid(): boolean {
		const licensingServiceSetting = this.productData.licensingServiceSetting;

		return !!(this.productData.title.trim().length > 0
			&& this.productData.description.trim().length > 0
			&& 	(
					!this.enableLicensingService
				||
					(
						licensingServiceSetting.acuityCreationSetting.acuityProductId
						&& licensingServiceSetting.subProductConfiguration.products[0]
						&& licensingServiceSetting.subProductConfiguration.products[0].id
						&& licensingServiceSetting.subProductConfiguration.products[0].creationTrigger
						&& licensingServiceSetting.subProductConfiguration.products[1]
						&& licensingServiceSetting.subProductConfiguration.products[1].id
						&& licensingServiceSetting.subProductConfiguration.products[1].creationTrigger
					)
				)
			);
	}

	/**
	 * Replacement method to set the bool values of the product Form
	 * ToDo: migrate other bool fields to use this function
	 * @param activate
	 * @param path
	 */
	activateBoolField(activate: boolean, path: string): void {
		if (path) {
			let isValid = false;
			let field = this.productData;
			const pathArray = path.split('.');
			const fieldName = pathArray.pop();

			pathArray.forEach(splitPath => {
				if (splitPath in field) {
					field = field[splitPath];
					isValid = true;
				} else {
					isValid = false;
					console.error(`Field ${path} not existent`);
				}
			});

			if (isValid || fieldName in field) {
				field[fieldName] = activate;
				this.postActivateBoolField(path, activate);
			}
		}
	}

	/**
	 * Perform data updates after a bool field changes
	 * @param {String} path
	 * @param {Boolean} value
	 */
	postActivateBoolField(path:string, value: boolean): void {
		if (path.includes('isOrganizationLevel')) {
			if (value && this.classValuationIntegration.isDefaultProduct) {
				this.classValuationIntegration.isDefaultProduct = false;
				this.classValuationIntegration.isFhaProduct = false;
				this.classValuationIntegration.defaultFhaNumber = null;
				this.classValuationIntegration.optionSelected = [];
				this.classValuationIntegration.isOrderIncomeStatement = false;
				this.classValuationIntegration.isOrderRentSchedule = false;
				this.classValuationIntegration.productId = '';
            	this.classValuationIntegration.productName = '';
			}
		}

		if (path === 'insideMaps.enabled') {
			this.activateInsideMaps(value);
			if (!value) {
				this.productData.insideMaps.insideMapsId = '';
				this.productData.insideMaps.insideMapsName = '';
			}
		}
	}

    /**
     * set value for activate Product
     * @param activate
     */
    activateProduct(activate: boolean): void {
        this.productData.active = activate;
    }

    /**
     * set value is a BPO product
     * @param activate
     */
    activateBPOProdcut(activate: boolean) {
        this.productData.acuity.bpoProduct = activate;
    }

    /**
     * Set value is a 3DProduct
     * @param activate
     */
    activate3DProduct(activate: boolean) {
        this.productData.acuity.is3dProduct = activate;
    }

	/**
	 * Activate Licensing
	 * @param activate
	 */
	activateLicensing(activate: boolean) {
		this.enableLicensingService = activate;

		const licensingServiceSetting = new LicensingServiceSetting();

		if (this.enableLicensingService) {
			licensingServiceSetting.enabled = activate;

			this.acuityLicensingSubProductCreationTrigger1 = {
				id: 'Manage3DScan',
				name: 'Incoming Managed 3D Scan'
			};

			this.acuityLicensingSubProductCreationTrigger2 = {
				id: 'Manage3DScan',
				name: 'Incoming Managed 3D Scan'
			};
		}

		this.productData.licensingServiceSetting = {...licensingServiceSetting};
	}

    /**
     * set value for activate Inspection
     * @param activate
     */
    activateInspection(activate: boolean): void {
        this.productData.inspection.enabled = activate;
        this.productData.inspection.schema = null;
		this.productData.inspection.injectImagesIntoForm = false;
        this.schemaSelected = null;
        this.gsePreferenceSelected = new SubProductInfo();
    }

    /**
     * set value for keepinspection attr
     * @param activate
     */
    activateKeepInspection(activate: boolean): void {
        this.productData.inspection.keepInspection = activate;
    }

    /**
     * set value for inspection GSE fungible
     * @param activate
     */
    activateGseFungibility(activate: boolean): void {
        this.productData.inspection.gseFungible = activate;
    }

     /**
     * set value for inspection UPD
     * @param activate
     */
    activateUseUPD(activate: boolean): void {
        this.productData.inspection.useUPD = activate;
    }

    /**
     * set value for inspection GSE fungible
     *
     * @param activate
     * @param gseTodisable
     */
    disableGSESubmition(activate: boolean, gseTodisable: string): void {
        this.productData.inspection[gseTodisable] = activate;
    }

    /**
     * set value for activate InsideMaps
     * @param activate
     */
    activateInsideMaps(activate: boolean): void {
		this.productData.insideMaps.enabled = activate;
		this.productData.insideMaps.insideMapsFee = null;
		this.productData.insideMaps.sendListingLink = false;
		this.productData.insideMaps.sendPropertyReportPageLink = false;
        this.insideMapsSelected = new TrakingListModel();
    }

    /**
     * set value for
     * @param $event
     */
    activateAcuity(activate: boolean): void {
        this.productData.acuity = new TrackingSystemConfigurationInfo();
        this.productData.acuity.enabled = activate;
        this.acuitySelected = [];
        this.sideCar1 = new SubProductInfo();
        this.sideCar2 = new SubProductInfo();
        if (!activate) {
            this.activateInsideMaps(false);
            this.activateInspection(false);
            this.activateKeepInspection(false);
            this.activateGseFungibility(false);
        }
    }

    /**
     * Activate Section
     */
    activateSection(integration: string, activate: boolean): void {
        let hasSelection;
        if (!this.productData.nexsys.enabled && !activate) {
            hasSelection = false;
        } else {
            hasSelection = true;
        }
        this.productData[integration].enabled = activate;

        if (!activate || integration !== INTEGRATIONS[4]) {
            this.classValuationIntegration.isEnabled = activate;
        }

        this.classValuationIntegrationValues(integration, hasSelection);

        INTEGRATIONS.forEach(index => {
            if (index !== integration) {
                if (this.productData[index].enabled && activate) {
                    this.productData[index].enabled = !activate;
                    this.productData.appScope.enqueueCommunications = !activate;
                    this.productData.appScope.disableCommunications = !activate;
                }
            }
        });

        if (!activate) {
            this.productData[integration] = new TrackingSystemConfigurationInfo();
        }
    }

    /**
     * On generic integration selected
     * @param $event
     */
    onGenericIntegrationSelected($event: any): void {
        this.genericIntegrationSelected = $event;

        if ($event) {
            this.productData.integration.integrationId = $event.id;
            this.classValuationIntegration.isEnabled = true;
            this.classValuationIntegrationValues(INTEGRATIONS[4], true);
        } else {
            this.productData.integration.integrationId = null;
            this.classValuationIntegration.isEnabled = false;
            this.classValuationIntegrationValues('', false);
        }
    }

    /**
     * set values when valuetrust is selected or nexsys
     */
    private classValuationIntegrationValues(
        integration: string,
        hasSelection: boolean
    ): void {
        if (hasSelection) {
            this.classValuationIntegration.integrationName = integration;
            this.classValuationIntegration.optionSelected  = [];
            this.classValuationIntegration.integrationText = integration;

            switch (integration) {
                case 'valutrust':
                    this.classValuationIntegration.productList = this.valutrustProductList;
                    break;
                case 'xpanse':
                    this.classValuationIntegration.productList = this.xpanseProductList;
                    break;
                case 'nexsys':
                    this.classValuationIntegration.productList = this.nexsysProductList;
                    break;
                case 'fnc':
                    this.classValuationIntegration.productList = this.fncProductList;
                    break;
                case 'integration':

                    if (this.genericIntegrationSelected.id) {
                        this.genericIntegrationService.getIntegrationProducts(this.genericIntegrationSelected.id)
                            .pipe(takeUntil(this.atComponentDestroy))
                            .subscribe((result) => {
                            if (result) {
                                this.classValuationIntegration.productList = result.map((product: any) => {
                                    return {
                                        id: product.key,
                                        title: product.label
                                    };
                                });
                            }
                        });
                    }

                    this.classValuationIntegration.integrationText = this.genericIntegrationSelected.name;
                    break;
            }

            this.classValuationIntegration.defaultFhaNumber = '';
            this.classValuationIntegration.isFhaProduct = false;
            this.classValuationIntegration.isOrderIncomeStatement = false;
            this.classValuationIntegration.isOrderRentSchedule = false;
            this.classValuationIntegration.placeHolder = `Select a ${integration} product`;
            this.classValuationIntegration.productId = '';
            this.classValuationIntegration.productName = '';
        } else {
            this.classValuationIntegration.productList = [];
            this.classValuationIntegration.integrationName = '';
            this.classValuationIntegration.integrationText = '';
            this.classValuationIntegration.placeHolder = '';
            this.genericIntegrationSelected = {};
        }
    }

    /**
     * set value for default product nexsys and valutrust
     * @param isDefault
     */
    nexsysIsDefaultProduct(isDefault: boolean): void {
        this.classValuationIntegration.isDefaultProduct = isDefault;
        if (this.classValuationIntegration.isDefaultProduct) {
            this.classValuationIntegration.productId = 'unknown';
			this.productData.isOrganizationLevel = false;
        }
    }

    /**
     * set value for nexsys and valutrust
     * @param $event
     */
    onNexsysProductSelected($event: any): void {
        if ($event) {
            this.classValuationIntegration.productId = $event.id;
            this.classValuationIntegration.productName = $event.title;
        } else {
            this.classValuationIntegration.optionSelected = null;
            this.classValuationIntegration.productId = '';
            this.classValuationIntegration.productName = '';
        }
    }

    /**
     * set value for isFhaProduct
     * @param isFhaProduct
     */
    isFhaProcductNexsys(isFhaProduct: boolean): void {
        this.classValuationIntegration.isFhaProduct = isFhaProduct;
    }

    /**
     * set value for isOrderIncomeStatement
     * @param isIncomeStatement
     */
    isOrderIncomeStatement(isIncomeStatement: boolean): void {
        this.classValuationIntegration.isOrderIncomeStatement = isIncomeStatement;
    }

    /**
     * set value for isOrderRentSchedule
     * @param rentSchedule
     */
    isOrderRentSchedule(rentSchedule: boolean): void {
        this.classValuationIntegration.isOrderRentSchedule = rentSchedule;
    }

    /**
     * set value for disble job
     * @param disableJob
     */
    disableAppScopeJob(disableJob: boolean): void {
        if (disableJob) {
            this.enqueueScopeJob(!disableJob);
        }
        this.productData.appScope.disableCommunications = disableJob;
    }

    /**
     * set value for disble job
     * @param disableJob
     */
    disableAcuityJob(disableJob: boolean): void {
        this.productData.acuity.disableCommunications = disableJob;
    }

    /**
     * set value for enqueue job
     * @param enqueueJob
     */
    enqueueScopeJob(enqueueJob: boolean): void {
        if (enqueueJob) {
            this.disableAppScopeJob(!enqueueJob);
        }
        this.productData.appScope.enqueueCommunications = enqueueJob;
    }

    /**
     * set value for Email to Additional Comments
     * @param hasAdditionalComments
     */
    emailToAdditionalComments(hasAdditionalComments: boolean): void {
        this.productData.appScope.borrowerEmailToComments = hasAdditionalComments;
    }

    /**
     * set value for enqueue job
     * @param $event
     */
    onAssociatedProductSelected($event: any): void {
        if ($event) {
            this.productData.appScope.associatedOrderProductType = $event.id;
            this.productData.appScope.associatedOrderProductName = $event.title;
        } else {
            this.associatedProductSelected = null;
            this.productData.appScope.associatedOrderProductType = '';
            this.productData.appScope.associatedOrderProductName = '';
        }
    }

    /**
     * set value for activate appScope
     * @param activate
     */
    activateAppScope(activate: boolean): void {
        this.productData.appScope = new AppScopeTrakingConfigurationInfo();
        this.productData.appScope.enabled = activate;
        this.appScopeSelected = [];
    }

    // DROPDOWN EVENTS

    /**
     * set value for GSE
     * @param $event
     */
    onGSEPreferenceSelected($event: any): void {
        if ($event) {
            this.productData.inspection.gsePreference = $event.id;
        } else {
            this.productData.inspection.gsePreference = null;
        }
    }

    /**
     * set value for Schema
     * @param $event
     */
    onSchemaSelected($event: any): void {
        if ($event) {
            this.productData.inspection.schema = $event.name;
			if (['InspectionReport:4.0'].indexOf(this.productData.inspection.schema) === -1) {
				this.productData.inspection.useUPD = false;
			}
        } else {
            this.productData.inspection.schema = null;
        }
    }

    /**
     * set value for Software Collector
     * @param softwareCollector
     */
    onSoftwareCollectorSelected(softwareCollector: string): void {
        this.productData.insideMaps.insideMapsId = '';
        this.productData.insideMaps.insideMapsName = '';
        this.productData.insideMaps.insideMapsFee = null;
		this.productData.insideMaps.sendListingLink = false;
		this.productData.insideMaps.sendPropertyReportPageLink = false;
        this.insideMapsSelected = new TrakingListModel();

        this.productData.inspection.softwareCollector = softwareCollector;
        this.productData.insideMaps.enabled =
            this.productData.inspection.softwareCollector === 'InsideMaps'
                ? true
                : false;
    }

    /**
     * set value for insideMap
     * @param $event
     */
    onInsideMapsProductSelected($event: any): void {
        if ($event) {
            this.productData.insideMaps.insideMapsId = $event.id;
            this.productData.insideMaps.insideMapsName = $event.title;
        } else {
            this.productData.insideMaps.insideMapsId = '';
            this.productData.insideMaps.insideMapsName = '';
            this.productData.insideMaps.insideMapsFee = null;
			this.productData.insideMaps.sendListingLink = false;
			this.productData.insideMaps.sendPropertyReportPageLink = false;
        }
    }

    /**
     * set value for fee values
     * @param $event
     */
    onFeeSetValue($event: any, type: string): void {
        const fee = Math.abs($event.value) >= 0 ? Math.abs($event.value) : null;
        if (type === 'insideMaps') {
            this.productData.insideMaps.insideMapsFee = fee;
        }
        if (type === 'sideCar') {
            this.sideCar1.subProductFee = fee;
        }
    }

    /**
     * select origin source irder
     * @param $event
     */
    onOriginSelected($event: any, mode: string = NEW_MODE): void {
        this.productData.origin = $event ? $event.id : null;
        this.getSubProductByOrigin(this.productData.origin);
        if (!$event) {
            this.handleFieldMsg('', NEW_MODE);
            return;
        }
        this.handleFieldMsg($event.id, mode);

        if (mode === NEW_MODE) {
            this.productData.licensingServiceSetting = new LicensingServiceSetting();
        }
    }

    /**
     * select the business line
     * @param $event
     */
    onLineBusinessSelected($event: any): void {
        this.lineSelected = $event?.name? $event : null;
    }

    /**
     * toggle the invoise appscope option
     * @param $event
     */
    toogleInvoiceOptionAppScope($event: any): void {
        this.productData.appScope.invoice = !this.productData.appScope.invoice;
    }

    /**
     * toggle the invoise acuity option
     * @param $event
     */
    toogleInvoiceOptionAcuity($event: any): void {
        this.productData.acuity.invoice = !this.productData.acuity.invoice;
    }

    /**
     * get subproduct by origin
     * @param origin
     */
    getSubProductByOrigin(origin: string): void {
        if (!origin || origin === 'Acuity') {
            this.subProductList = [];
            return;
        }
        this.productService.getProdcutListByOrigin(origin)
            .pipe(takeUntil(this.atComponentDestroy))
            .subscribe((result) => {
            this.subProductList = result.data.map((s) => {
                const { id, title } = s;
                return {
                    id,
                    name: title,
                };
            });
        });
    }

    /***
     * set msg field depend on selected option
     */
    handleFieldMsg(type: string, mode: string): void {
        this.showLicensingButton = false;
        switch (type) {
            case MSG_FIELDS_OPTIONS.ACUITY:
                this.hasOrigin = true;
                this.productData.appScope.enabled = false;
                this.enableAcuityMsg = MSG_FIELDS_VALUE.ACUITYCHECK.ACUITY;
                this.enableAppScopeMsg = MSG_FIELDS_VALUE.ACUITYCHECK.SCOPE;
                if (mode === NEW_MODE) {
                    this.productData.appScope.enabled = false;
                    this.activateAcuity(true);
                }
                this.canSetNexsys = false;
                this.canSetAcuity = true;
                this.canSetAppScope = false;
                this.canSetSideCar = false;
                break;
			case MSG_FIELDS_OPTIONS.CMPACUITY:
                this.hasOrigin = true;
                this.productData.appScope.enabled = false;
                this.enableAcuityMsg = MSG_FIELDS_VALUE.ACUITYCHECK.ACUITY;
                this.enableAppScopeMsg = MSG_FIELDS_VALUE.ACUITYCHECK.SCOPE;
                if (mode === NEW_MODE) {
                    this.activateAcuity(true);
                }
                this.canSetNexsys = false;
                this.canSetAcuity = true;
                this.canSetAppScope = false;
                this.canSetSideCar = true;
                break;
            case MSG_FIELDS_OPTIONS.CLASSORDERENTRY:
            case MSG_FIELDS_OPTIONS.APPSCOPE:
                this.hasOrigin = true;
                this.enableAcuityMsg = MSG_FIELDS_VALUE.APPSCOPECHECK.ACUITY;
                this.enableAppScopeMsg = MSG_FIELDS_VALUE.APPSCOPECHECK.SCOPE;
                if (mode === NEW_MODE) {
                    this.productData.acuity.enabled = false;
                    this.activateAppScope(true);
                    this.activateAcuity(false);
                }
                this.canSetNexsys = false;
                this.canSetAcuity = true;
                this.canSetAppScope = true;
                this.canSetSideCar = true;
                if (type === MSG_FIELDS_OPTIONS.CLASSORDERENTRY) {
                    this.showLicensingButton = true;
                }
                break;
            case MSG_FIELDS_OPTIONS.CLASSVALUATION:
                this.hasOrigin = true;
                this.enableAcuityMsg = MSG_FIELDS_VALUE.DEFAULT.ACUITY;
                this.enableAppScopeMsg = MSG_FIELDS_VALUE.DEFAULT.SCOPE;
                if (mode === NEW_MODE) {
                    this.activateAcuity(false);
                    this.activateAppScope(false);
                }
                this.canSetAcuity = true;
                this.canSetAppScope = true;
                this.canSetSideCar = true;
                this.canSetNexsys = true;
                break;
            default:
                this.hasOrigin = false;
                if (mode === NEW_MODE) {
                    this.activateAcuity(false);
                    this.activateAppScope(false);
                }
                this.canSetAcuity = false;
                this.canSetAppScope = false;
                this.canSetSideCar = false;
                this.canSetNexsys = false;
                break;
        }
    }

    /**
     * set value for nexsys attribute
     * @param $event
     */
    onNexsysAttributeSelected($event: any): void {
        if ($event && $event.length) {
            this.productData.nexsys.orderAttribute = $event.map((atr) => {
                return atr.title;
            });
        } else {
            this.productData.nexsys.orderAttribute = [];
        }
    }

    /**
     * set value for acuity
     * @param $event
     */
    onAcuityProductSelected($event: any): void {
        if ($event) {
            this.productData.acuity.productId = $event.id;
            this.productData.acuity.productName = $event.title;
        } else {
            this.productData.acuity.productId = '';
            this.productData.acuity.productName = '';
        }
    }

    /**
     * Set Acuity Product
     * @param $event
     */
    onAcuityLicensingProductSelected($event: any): void {
        if ($event) {
            this.productData.licensingServiceSetting.acuityCreationSetting.acuityProductId   = $event.id;
            this.productData.licensingServiceSetting.acuityCreationSetting.acuityProductName = $event.title;
        } else {
            this.productData.licensingServiceSetting.acuityCreationSetting.acuityProductId   = '';
            this.productData.licensingServiceSetting.acuityCreationSetting.acuityProductName = '';
        }
    }

    /**
     * Set Value For Acuity SubProduct
     * @param $event
     */
    onAcuityLicensingSubProductSelected($event: any, subProductNumber: number): void {
        const productsData = this.productData.licensingServiceSetting.subProductConfiguration.products[subProductNumber];

        if ($event) {
            productsData.id = $event.id;
            productsData.name = $event.name;
        } else {
            productsData.id = null;
            productsData.name = null;
        }

        this.productData.licensingServiceSetting.subProductConfiguration.products[subProductNumber] = productsData;
    }

    /**
     * Select assign to
     * @param $event
     */
    onLicensingSubProductCreationTriggerSelected($event: any, subProductNumber: number): void {
        const productsData = this.productData.licensingServiceSetting.subProductConfiguration.products[subProductNumber];

        productsData.creationTrigger = $event ? $event.id : null;

        this.productData.licensingServiceSetting.subProductConfiguration.products[subProductNumber] = productsData;
    }

    /**
     * set value for acuity
     * @param $event
     */
    onaAppScopeProductSelected($event: any): void {
        if ($event) {
            this.productData.appScope.jobId = $event.id;
            this.productData.appScope.jobName = $event.title;
        } else {
            this.productData.appScope.jobId = '';
            this.productData.appScope.jobName = '';
        }
    }

    /**
     * set value for creationTrigger
     * @param $event
     */
    onaCreationTriggerSelected($event: any, type: string): void {
        if ($event && type === 'appScope') {
            this.productData.appScope.creationTrigger = $event.id;
        }
        if (!$event && type === 'appScope') {
            this.creationTriggerSelected = this.creationTriggerList[0];
            this.productData.appScope.creationTrigger = '';
        }
        if ($event && type === 'sideCar') {
            this.sideCar1.creationTrigger = $event.id;
        }
        if (!$event && type === 'sideCar') {
            this.creationTriggerSubProductSelected = this.creationTriggerList[0];
            this.sideCar1.creationTrigger = this.creationTriggerSubProductSelected.id;
            this.sideCar1.creationStatusTrigger = null;
        }
    }

    /**
     * set value for milestone
     * @param $event
     */
    onaMilestoneSelected($event: any, type: string): void {
        if ($event && type === 'appScope') {
            this.productData.appScope.creationStatusTrigger = $event.id;
        }
        if (!$event && type === 'appScope') {
            this.productData.appScope.creationStatusTrigger = '';
        }

        if ($event && type === 'sideCar') {
            this.sideCar1.creationStatusTrigger = $event.id;
        }
        if (!$event && type === 'sideCar') {
            this.sideCar1.creationStatusTrigger = null;
        }
    }

    /**
     * set value for milestone
     * @param $event
     */
    onDMLinkSelected($event: any): void {
        if ($event) {
            this.productData.acuity.bpoLinkTrigger = $event.id;
        } else {
            this.productData.acuity.bpoLinkTrigger = '';
        }
    }

    /**
     * set value for assets on completion
     * @param $event
     * @param
     */
    onaAssetsonCompletionSelected($event: any, origin: string): void {
        if ($event && origin === 'appscope') {
            this.productData.appScope.productAssetDescription = $event.description;
            this.productData.appScope.productAssetsId = $event.id;
        }
        if (!$event && origin === 'appscope') {
            this.productData.appScope.productAssetDescription = null;
            this.productData.appScope.productAssetsId = null;
        }

        if ($event && origin === 'acuity') {
            this.productData.acuity.productAssetDescription = $event.description;
            this.productData.acuity.productAssetsId = $event.id;
        }

        if (!$event && origin === 'acuity') {
            this.productData.acuity.productAssetDescription = null;
            this.productData.acuity.productAssetsId = null;
        }
    }

    /**
     * set value for
     * @param $event
     */
    onSideCardConfigProductSelected($event: any, card: number): void {
        if (!$event && card === 1) {
            this.sideCar1.name = null;
            this.sideCar1.id = null;
            this.sideCar1.subProductFee = null;
            return;
        }
        if (!$event && card === 2) {
            this.sideCar2.name = null;
            this.sideCar2.id = null;
            return;
        }
        const { id, name } = $event;
        if (card === 1) {
            this.sideCar1.id = id;
            this.sideCar1.name = name;
        } else {
            this.sideCar2.id = id;
            this.sideCar2.name = name;
        }
    }

    /**
     * handle response from server
     */
    successHandleFunction(): void {
        this.productService.setSavingProductData({ saving: false });
        this.router.navigate([`/global-configuration/product/product-list`]);
        const msgSuget = this.productId ? 'Updated' : 'Created';
        const msg = `The Product was ${msgSuget} successfully`;
        this.broadcastService.broadcast({
            name: ToasterType.SUCCESS,
            event: { message: msg },
        });
    }

    onAutoCompleteScopeOrder(autoComplete: boolean): void {
        this.productData.acuity.autoCompleteScopeOrderOption.autoComplete = autoComplete;
    }

    onUploadDocumentsScopeOrder(uploadDocuments: boolean): void {
        this.productData.acuity.autoCompleteScopeOrderOption.uploadDocuments = uploadDocuments;
    }

    /**
     * set value for milestone
     * @param $event
     */
    onAutoCompleteMilestoneSelected($event: any): void {
        if ($event.length) {
            this.productData.acuity.autoCompleteScopeOrderOption.autoCompleteMilestoneTrigger = $event[0].id;
        } else {
            this.productData.acuity.autoCompleteScopeOrderOption.autoCompleteMilestoneTrigger = '';
        }
    }

    /**
     * set value for milestone
     * @param $event
     */
    onUploadDocumentsMilestoneSelected($event: any): void {
        if ($event.length) {
            this.productData.acuity.autoCompleteScopeOrderOption.uploadDocumentsMilestone = $event[0].id;
        } else {
            this.productData.acuity.autoCompleteScopeOrderOption.uploadDocumentsMilestone = '';
        }
    }

    /**
	 * Register Listener for update documents
	 */
	private registerUpdateDocumentsListener(): void {
		this.broadcastService.on(SCOPE_ORDER_UPDATE_DOCUMENTS, (broadcast: BroadcastEventModel) => {
            this.productData.acuity.autoCompleteScopeOrderOption.documents = broadcast.event.data;
		});
	}

    /**
	 * Return to product list
	 */
	returnToProductList(): void {
		this.router.navigate(['/global-configuration/product/product-list']);
	}

    /**
	 * looks for the schema version 4.0
	 */
    get showUPDInfo(): boolean {
        return ['InspectionReport:4.0'].indexOf(this.productData.inspection.schema)!= -1 &&
                this.productData.acuity.is3dProduct &&
                this.productData.inspection.enabled;
    }

    ngOnDestroy(): void {
        this.atComponentDestroy.next({});
        this.atComponentDestroy.unsubscribe();
    }

	/**
	 * Event when the user select the acuity origin data
	 * @param $event
	 */
	onAcuityTypeSelected($event: any): void {
		this.acuityOriginSelected = $event?.name || null;
        this.acuitySelected = [];
		this.productData.acuity = new TrackingSystemConfigurationInfo();
		this.productData.inspection = new InspectionConfiguration();
		this.productData.acuity.enabled = true;
		this.productData.acuity.instance = $event?.id;
		this.sideCar1 = new SubProductInfo();
		this.sideCar2 = new SubProductInfo();
		this.activateInsideMaps(false);
		this.activateInspection(false);
		this.activateKeepInspection(false);
		this.activateGseFungibility(false);
		this.schemaSelected = null;
		this.dmLinkSelected = null;
		this.autoCompleteMilestoneSelected = [];
		this.uploadDocumentsMilestoneSelected = [];

		this.setAcuityOptionsList($event?.id);
	}

	/**
	 * Event to set products & milestones list from acuity or cmp acuity
	 * @param origin
	 */
	setAcuityOptionsList(origin: string): void {
		this.acuityProductList = [];
		this.milestoneAcuityList = [];

		switch(origin) {
			case 'acuity':
				this.acuityProductList = this.store.selectSnapshot(GlobalConfigurationState.getAcuityProducts);
				this.milestoneAcuityList = this.store.selectSnapshot(GlobalConfigurationState.getAcuityMilestones);
				break;
			case 'cmpacuity':
				this.acuityProductList = this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityProducts);
				this.milestoneAcuityList = this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityMilestones);
				break;
		}
	}

	/**
	 * event to set hybrid mode in subproduct configuration
	 * @param $event
	 */
	setHybridMode($event: any, card: number): void {
		if(card === 1) {
			this.sideCar1.hybridMode = $event || false;
		}

		if (card === 2){
			this.sideCar2.hybridMode = $event || false;
		}

	}
}
